const deleteButton = `<svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
<path opacity="0.6" d="M12.3776 2.91785H15.805C16.1888 2.91785 16.5 3.23753 16.5 3.63185C16.5 4.02617 16.1888 4.34584 15.805 4.34584H14.3677V14.7961C14.3677 15.7372 13.6252 16.5 12.7093 16.5H3.95903C3.0431 16.5 2.30059 15.7372 2.30059 14.7961V4.34584H1.19497C0.811155 4.34584 0.5 4.02617 0.5 3.63185C0.5 3.23753 0.811155 2.91785 1.19497 2.91785H4.29072V1.50609C4.29072 0.950434 4.72915 0.5 5.26999 0.5H11.3983C11.9392 0.5 12.3776 0.950434 12.3776 1.50609V2.91785ZM10.9877 2.91785V1.92799H5.68065V2.91785H10.9877ZM3.69052 4.36207V14.7961C3.69052 14.9485 3.81074 15.072 3.95903 15.072H12.7093C12.8576 15.072 12.9778 14.9485 12.9778 14.7961V4.36207H3.69052ZM6.28085 12.5243C6.28085 12.9187 5.96969 13.2383 5.58588 13.2383C5.20207 13.2383 4.89092 12.9187 4.89092 12.5243V6.55274C4.89092 6.15842 5.20207 5.83874 5.58588 5.83874C5.96969 5.83874 6.28085 6.15842 6.28085 6.55274V12.5243ZM9.19497 12.5243C9.19497 12.9187 8.88381 13.2383 8.5 13.2383C8.11619 13.2383 7.80503 12.9187 7.80503 12.5243V6.55274C7.80503 6.15842 8.11619 5.83874 8.5 5.83874C8.88381 5.83874 9.19497 6.15842 9.19497 6.55274V12.5243ZM12.117 12.5243C12.117 12.9187 11.8058 13.2383 11.422 13.2383C11.0382 13.2383 10.727 12.9187 10.727 12.5243V6.55274C10.727 6.15842 11.0382 5.83874 11.422 5.83874C11.8058 5.83874 12.117 6.15842 12.117 6.55274V12.5243Z" fill="black" fill-opacity="0.6"></path>
</svg>`
document.addEventListener('DOMContentLoaded', function () {
  // Check if we're coming from the edit bundle link
  const urlParams = new URLSearchParams(window.location.search);

  class MiniCart {
    constructor(options) {
      this.searchInput = document.getElementById(options.searchInput);
      this.resultsContainer = document.getElementById(options.resultsContainer);
      this.miniCartContainer = document.getElementById(options.miniCartContainer);
      this.addBundleBtn = document.getElementById(options.addBundleBtn);

      this.cartItems = {};
      this.searchResults = {};
      this.activeSearchController = null;

      // NEW: Wait for init, then run logic
      this.init().then(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const lastPageURL = sessionStorage.getItem('previousPage') || 'bundle';

        if (urlParams.get('edit-bundle') === 'true') {
          this.clearCart();
          this.loadBundleFromShopify();
        }
        this.initPreMadeBundles();
      });
    }


    initPreMadeBundles() {
      document.querySelectorAll('.addBundle').forEach(button => {
        button.addEventListener('click', (e) => {
          const bundleId = e.target.id.replace('bundle_', '');
          this.addPreMadeBundleToCart(bundleId);

        });
      });

    }

    // Add this method to handle pre-made bundles
    async addPreMadeBundleToCart(bundleId) {
      try {
        const bundleContainer = document.querySelector(`#bundle_${bundleId}`)?.closest('.pre-made-bundle-product-details');
        if (!bundleContainer) {
          console.error('Bundle container not found');
          return;
        }

        const bundleProductItems = bundleContainer.querySelectorAll('.bundle-product-item');

        for (const productItem of bundleProductItems) {
          const productHandle = productItem.dataset.productHandle;
          if (productHandle) {
            const product = await fetch(`/products/${productHandle}.js`).then(res => res.json());
            if (product && product.variants && product.variants.length > 0) {
              const variant = product.variants[0];
              const addButton = {
                dataset: {
                  productHandle: product.handle,
                  variantId: variant.id.toString(),
                  productTitle: product.title,
                  productPrice: variant.price,
                  productImage: product.featured_image || '/assets/no-image.png'
                }
              };
              this.addToMiniCart(addButton);
            }
          }
        }

        if (window.innerWidth <= 767) {
          document.querySelector('.bundle-mini-cart-side').classList.add('open');
          document.querySelector('body')?.classList.add('bundle-overflow');
          document.querySelector('.mobile-bundle__overlay')?.classList.add('show-overlay');
          document.querySelector('#mobile_bundle_text').scrollIntoView({ behavior: 'smooth' });
        }

      } catch (error) {
        console.error('Error adding bundle to cart:', error);
      }
    }

    async init() {
      this.bindEvents();

      const headerCur = document.querySelector('header.header');
      const currentCurrency = headerCur?.getAttribute('data-currency-symbol') || '';

      const storedCurrency = localStorage.getItem('cart_currency_symbol');

      if (storedCurrency && storedCurrency === currentCurrency) {
        await this.loadCartFromStorage();
      } else {
        localStorage.removeItem('cart');
      }

      localStorage.setItem('cart_currency_symbol', currentCurrency);

      this.updateCartUI();
    }

    async loadBundleFromShopify() {
      try {
        const res = await fetch('/cart.js');
        const cart = await res.json();

        const bundleItems = cart.items.filter(
          (item) => item.properties && item.properties['bundle-product'] === 'true'
        );
        console.log('bundleItems.length', bundleItems.length);
        if (!bundleItems.length) return;

        for (const item of bundleItems) {
          const variantId = item.variant_id.toString();
          const handle = item.handle;
          const quantity = item.quantity;
          const title = item.title;
          const image = item.image;
          const price = item.original_price;

          const itemEl = document.createElement('div');
          itemEl.className = 'mini-cart-row';
          itemEl.innerHTML = `
              <div class="product-info">
                <div class="pdp-img-wrapper"><img src="${image}" alt="${title}" class="product-image" /></div>
                <div>
                  <div class="product-title">${title}</div>
                  <div class="product-variant price-display">${this.formatPrice(price, quantity)}</div>
                </div>
              </div>
              <div class="quantity-controls">
                <button class="decrease">-</button>
                <span class="qty">${quantity}</span>
                <button class="increase">+</button>
              </div>
              <button class="delete-button">${deleteButton}</button>
          `;

          this.cartItems[variantId] = {
            quantity,
            handle,
            price,
            title,
            image,
            element: itemEl,
          };

          this.miniCartContainer.querySelector('.min-cart-item').appendChild(itemEl);
        }

        this.updateCartUI();
      } catch (err) {
        console.error('Error loading bundle from Shopify cart:', err);
      }
    }

    bindEvents() {
      // Single delegated event listener for all cart actions
      document.addEventListener('click', (e) => {
        if (e.target.closest('.addtominicart')) {
          this.addToMiniCart(e.target.closest('.addtominicart'));
        } else if (e.target.closest('.delete-button')) {
          this.deleteFromMiniCart(e.target);
        } else if (e.target.closest('.delete-from-grid')) {
          this.deleteAllFromGrid(e.target);
        } else if (e.target.closest('.increase') || e.target.closest('.decrease')) {
          this.changeQuantity(e.target);
        }
      });

      this.searchInput?.addEventListener('input', (e) => {
        this.handleSearch(e.target.value.trim());
      });

      this.addBundleBtn?.addEventListener('click', () => this.addBundleToShopify(this.addBundleBtn));
      // Handle accordion toggle events for slider refresh
      document.querySelectorAll('details').forEach(details => {
        details.addEventListener('toggle', () => {
          if (details.open) {
            this.refreshSlidersInElement(details);
          }
        });
      });
    }

    // Centralized price formatting
    formatPrice(priceInCents, quantity = 1) {
      // Convert to pounds (assuming price is in pence/cents)
      const priceInPounds = (priceInCents / 100) * quantity;
      const headerEle = document.querySelector('header.header');
      const currencySymbol = headerEle?.getAttribute('data-currency-symbol') || '';
      return `${priceInPounds.toFixed(2)}${currencySymbol}`;
    }

    updateQuantityDisplay(element) {
      const handle = element?.dataset?.productHandle;
      if (!handle) return;

      const qty = this.getTotalQuantityByHandle(handle);
      const qtyNumber = element.querySelector('.quantity-number');

      if (qtyNumber) {
        qtyNumber.textContent = qty;
        element.classList.toggle('hidden', qty <= 0);
      }
    }

    updateAllQuantityDisplays() {
      const displays = [
        ...document.querySelectorAll('#searchResults .quantity-display'),
        ...document.querySelectorAll('.product-grid .quantity-display, .grid__item .quantity-display'),
        ...document.querySelectorAll('.collection-grid .quantity-display'),
      ];

      displays.forEach((display) => this.updateQuantityDisplay(display));
    }

    async handleSearch(query) {
      // Cancel previous search if it exists
      if (this.activeSearchController) {
        this.activeSearchController.abort();
      }

      this.resultsContainer.innerHTML = '';
      if (!query.trim()) return;

      // Create new controller for this search
      this.activeSearchController = new AbortController();

      try {
        const response = await fetch(
          `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=10`,
          {
            signal: this.activeSearchController.signal,
            timeout: 5000,
          }
        );

        // Check if the request was aborted
        if (this.activeSearchController.signal.aborted) {
          return;
        }

        const data = await response.json();

        const products = (data.resources.results.products || [])
          .filter((p, i, arr) => arr.findIndex((item) => item.handle === p.handle) === i)
          .slice(0, 10);

        if (!products.length) {
          this.resultsContainer.innerHTML = `
            <div class="no-product-filter-text" style="text-align: center;width: 100%;">
            <img 
                src="https://cdn.shopify.com/s/files/1/0916/2411/2465/files/oops-img_2702a0aa-3b25-4858-b7ea-98a39ea3e11b.jpg?v=1759990660" 
                alt="" 
                width="200" 
                height="113"
            >
            <p>
                <b>Kein Ergebnis</b><br>
                Die von Ihnen gewählte Filter stimmen nicht mit unseren Produkten überein. Bitte setze den Filter zurück und ändere deine Suchanfrage.
            </p>
            </div>
        `;
          return;
        }

        const cards = await Promise.all(products.map((product) => this.fetchProductCard(product.handle)));

        // Check if aborted again before DOM updates
        if (this.activeSearchController.signal.aborted) {
          return;
        }

        this.resultsContainer.innerHTML = '';
        cards.filter(Boolean).forEach((card) => {
          this.updateQuantityDisplay(card.querySelector('.quantity-display'));
          this.resultsContainer.appendChild(card);
        });

        // Initialize search results slider
        this.initSearchResultsSlider();
      } catch (err) {
        // Only show error if it wasn't an abort
        if (err.name !== 'AbortError') {
          // this.resultsContainer.innerHTML = '<p>Error loading products</p>';
          console.error('Search error:', err);
        }
      }
    }


    initSearchResultsSlider() {
      if (typeof $.fn.owlCarousel !== 'undefined') {
        // Destroy existing slider if it exists
        if ($('#searchResults').hasClass('owl-loaded')) {
          $('#searchResults').trigger('destroy.owl.carousel').removeClass('owl-loaded');
        }

        // Initialize new slider
        $('#searchResults').owlCarousel({
          loop: false,
          nav: true,
          dots: false,
          responsive: {
            0: { items: 2, margin: 12, nav: false },
            480: { items: 2, margin: 12, nav: false },
            500: { items: 2, margin: 12, nav: false },
            768: { items: 2, margin: 30, nav: false },
            1024: { items: 3, margin: 30 }
          }
        });
      }
    }

    refreshSlidersInElement(element) {
      if (typeof $.fn.owlCarousel !== 'undefined') {
        $(element).find('.owl-carousel').each(function () {
          const $this = $(this);
          if ($this.hasClass('owl-loaded')) {
            $this.trigger('refresh.owl.carousel');
          } else {
            // Reinitialize if not already initialized
            $this.owlCarousel({
              loop: true,
              nav: true,
              dots: false,
              responsive: {
                0: { items: 2, margin: 12, nav: false },
                480: { items: 2, margin: 12, nav: false },
                500: { items: 2, margin: 12, nav: false },
                768: { items: 2, margin: 12, nav: false },
                1024: { items: 3, margin: 30 }
              }
            });
          }
        });
        if (!element.classList.contains('owl-carousel-loaded')) {
          setTimeout(() => {
            element.classList.add('owl-carousel-loaded');
          }, 3000);
        }
      }
    }

    // Helper method to fetch individual product cards
    async fetchProductCard(handle) {
      try {
        const response = await fetch(`/products/${handle}?section_id=bundle-search-product`, {
          signal: this.activeSearchController.signal,
        });

        if (this.activeSearchController.signal.aborted) {
          return null;
        }

        const html = await response.text();
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;
        return tempDiv.querySelector('.grid__item');
      } catch (err) {
        if (err.name !== 'AbortError') {
          console.error(`Error loading product ${handle}:`, err);
        }
        return null;
      }
    }

    saveCartToStorage() {
      const data = Object.entries(this.cartItems).reduce((acc, [id, item]) => {
        acc[id] = {
          quantity: item.quantity,
          handle: item.handle,
          price: item.price,
          title: item.title,
          image: item.image,
        };
        return acc;
      }, {});
      localStorage.setItem('miniCart', JSON.stringify(data));
    }

    async loadCartFromStorage() {
      try {
        const saved = localStorage.getItem('miniCart');
        if (!saved) return;

        const data = JSON.parse(saved);

        // Correct way to iterate through object entries
        for (const [variantId, itemData] of Object.entries(data)) {
          const { handle, quantity, price, title, image } = itemData;

          const product = await fetch(`/products/${handle}.js`).then((res) => res.json());
          if (!product.variants.some((v) => v.id == variantId)) continue;

          const itemEl = document.createElement('div');
          itemEl.className = 'mini-cart-row';
          itemEl.innerHTML = `
            <div class="product-info">
              <div class="pdp-img-wrapper"><img src="${image}" alt="${title}" class="product-image" /></div>
              <div>
                <div class="product-title">${title}</div>
                <div class="product-variant price-display">${this.formatPrice(price, quantity)}</div>
              </div>
            </div>
            <div class="quantity-controls">
              <button class="decrease">-</button>
              <span class="qty">${quantity}</span>
              <button class="increase">+</button>
            </div>
            <button class="delete-button">${deleteButton}</button>
          `;

          this.cartItems[variantId] = {
            ...itemData,
            element: itemEl,
          };
          this.miniCartContainer.querySelector('.min-cart-item').appendChild(itemEl);
        }

        this.updateCartUI();
      } catch (err) {
        console.error('Error loading cart:', err);
      }
    }

    clearCart() {
      // Clear from memory
      this.cartItems = {};

      // Clear from UI
      this.miniCartContainer.querySelector('.min-cart-item').innerHTML = '';

      // Clear from localStorage
      localStorage.removeItem('miniCart');

      // Update UI to reflect empty cart
      this.updateCartUI();

      console.log('Cart cleared successfully');
    }

    async addToMiniCart(button) {
      const handle = button.dataset.productHandle;
      const variantId = button.dataset.variantId;
      const title = button.dataset.productTitle;
      const price = Number(button.dataset.productPrice);
      const image = button.dataset.productImage;

      try {
        button.setAttribute('disabled', true);
        const product = await fetch(`/products/${handle}.js`).then((res) => res.json());
        if (!product.variants.some((v) => v.id == variantId)) return;

        if (this.cartItems[variantId]) {
          this.cartItems[variantId].quantity++;
          const { element, price } = this.cartItems[variantId];
          element.querySelector('.qty').textContent = this.cartItems[variantId].quantity;
          element.querySelector('.price-display').textContent = this.formatPrice(
            price,
            this.cartItems[variantId].quantity
          );
        } else {
          const itemEl = document.createElement('div');
          itemEl.className = 'mini-cart-row';
          itemEl.innerHTML = `
            <div class="product-info">
              <div class="pdp-img-wrapper"><img src="${image}" alt="${title}" class="product-image" /></div>
              <div>
                <div class="product-title">${title}</div>
                <div class="product-variant price-display">${this.formatPrice(price)}</div>
              </div>
            </div>
            <div class="quantity-controls">
              <button class="decrease">-</button>
              <span class="qty">1</span>
              <button class="increase">+</button>
            </div>
            <button class="delete-button" type="button">${deleteButton}</button>
        `;

          this.cartItems[variantId] = {
            quantity: 1,
            element: itemEl,
            handle,
            price,
            title,
            image,
          };
          this.miniCartContainer.querySelector('.min-cart-item').appendChild(itemEl);
        }
        button.removeAttribute('disabled', true)

        this.updateCartUI();
      } catch (err) {
        console.error('Error adding to cart:', err);
        button.removeAttribute('disabled', true)
      }
    }

    deleteFromMiniCart(button) {
      const itemEl = button.closest('.mini-cart-row');
      const variantId = Object.keys(this.cartItems).find((id) => this.cartItems[id].element === itemEl);
      if (!variantId) return;

      delete this.cartItems[variantId];
      itemEl.remove();
      this.updateCartUI();
    }

    deleteAllFromGrid(button) {
      const handle = button.closest('.quantity-display')?.dataset.productHandle;
      if (!handle) return;

      Object.keys(this.cartItems).forEach((variantId) => {
        if (this.cartItems[variantId].handle === handle) {
          this.cartItems[variantId].element.remove();
          delete this.cartItems[variantId];
        }
      });

      this.updateCartUI();
    }

    changeQuantity(button) {
      const itemEl = button.closest('.mini-cart-row');
      const variantId = Object.keys(this.cartItems).find((id) => this.cartItems[id].element === itemEl);
      if (!variantId) return;

      const isIncrease = button.classList.contains('increase');
      this.cartItems[variantId].quantity += isIncrease ? 1 : -1;

      if (this.cartItems[variantId].quantity <= 0) {
        itemEl.remove();
        delete this.cartItems[variantId];
      } else {
        const { price, quantity } = this.cartItems[variantId];
        itemEl.querySelector('.qty').textContent = quantity;
        itemEl.querySelector('.price-display').textContent = this.formatPrice(price, quantity);
      }

      this.updateCartUI();
    }

    getTotalQuantityByHandle(handle) {
      return Object.values(this.cartItems)
        .filter((item) => item.handle === handle)
        .reduce((sum, item) => sum + item.quantity, 0);
    }

    updateCartUI() {
      this.updateAllQuantityDisplays();
      this.updateTotals();
      this.updateEmptyCartMessage();
      this.updateBundleTiers();
      this.saveCartToStorage();
    }

    updateEmptyCartMessage() {
      const minCartItemContainer = this.miniCartContainer?.querySelector('.min-cart-item');
      if (!minCartItemContainer) return;

      const isEmpty = Object.keys(this.cartItems).length === 0;
      let emptyCartMessage = minCartItemContainer.querySelector('.empty-cart-message');
      const miniCart = document.querySelector('.bundle-mini-cart-side');

      if (isEmpty && !emptyCartMessage) {
        if (miniCart) {
          // Add the class
          miniCart.classList.add('min-cart-empty');
        }
        minCartItemContainer.innerHTML = `
          <div class="empty-cart-message">
            <div class="productBlockContent">
            <div class="productBlockImg">
            <img src="https://assetsv3.weightworld.uk/assets/weightworld/weightworld.uk/images/empty-grey-frame.webp" alt="Empty Product" width="80" height="80">
            </div>
            <div class="productBlockTitle">
            <h3 class="h3">Füge dein erstes Produkt hinzu</h3>
            </div>
            </div>
          </div>
        `;
      } else if (!isEmpty && emptyCartMessage) {
        if (miniCart) {
          miniCart.classList.remove('min-cart-empty');
        }
        emptyCartMessage.remove();
      }
    }

    updateBundleTiers() {
      const totalQty = Object.values(this.cartItems).reduce((sum, item) => sum + item.quantity, 0);

      // Update tier active states
      document.querySelectorAll('.bundle-tier').forEach((tier) => {
        const tierItems = parseInt(tier.dataset.items);
        tier.classList.toggle(
          'active',
          (totalQty === 3 && tierItems === 3) ||
          (totalQty === 4 && tierItems === 4) ||
          (totalQty >= 5 && tierItems === 5)
        );
      });

      // Update add bundle button disabled state
      const addBundleBtn = document.getElementById('add-bundle');
      const mobileBundleDrawerButton = document.querySelector('#mobile_bundle_text');
      if (addBundleBtn) {
        if (totalQty < 3) {
          addBundleBtn.setAttribute('disabled', 'disabled');
          //addBundleBtn.textContent = `Add ${3 - totalQty} more products to bundle`;
          mobileBundleDrawerButton.classList.add('less-treshold');
        } else {
          addBundleBtn.removeAttribute('disabled');
          // addBundleBtn.textContent = 'Add bundle to cart';
          mobileBundleDrawerButton.classList.remove('less-treshold');
        }
      }
    }

    updateTotals() {
      // Calculate subtotal and total quantity
      const { subtotal, totalQty } = Object.values(this.cartItems).reduce(
        (acc, item) => {
          // Ensure price is treated as a number
          const price = typeof item.price === 'string' ? parseFloat(item.price) : item.price;
          acc.subtotal += (price / 100) * item.quantity;
          acc.totalQty += item.quantity;
          return acc;
        },
        {
          subtotal: 0,
          totalQty: 0,
        }
      );

      // Calculate savings based on quantity tiers
      let saving = 0;
      if (totalQty === 3) saving = subtotal * 0.2;
      else if (totalQty === 4) saving = subtotal * 0.23;
      else if (totalQty >= 5) saving = subtotal * 0.25;

      const bundlePrice = subtotal - saving;

      // Safely update DOM elements
      const subtotalElement = document.querySelector('.subtotal-amount');
      const savingElement = document.querySelector('.saving-amount');
      const bundlePriceElement = document.querySelector('.bundle-price');

      if (subtotalElement) {
        subtotalElement.textContent = this.formatPrice(subtotal * 100);
      }
      if (savingElement) {
        savingElement.textContent = this.formatPrice(saving * 100);
      }
      if (bundlePriceElement) {
        bundlePriceElement.textContent = this.formatPrice(bundlePrice * 100);
      }
    }
    async addBundleToShopify(addBundleBtn) {
      if (Object.keys(this.cartItems).length === 0) {
        alert('No items to add.');
        return;
      }

      try {

        const currentUrl = new URL(window.location.href);
        // Remove the 'edit-bundle' query parameter and update url
        currentUrl.searchParams.delete('edit-bundle');
        window.history.replaceState({}, document.title, currentUrl.toString());

        addBundleBtn.setAttribute('disabled', 'disabled');

        // 1. Get current cart
        const cartRes = await fetch('/cart.js');
        const cart = await cartRes.json();

        // 2. Collect bundle line item keys
        const bundleKeys = cart.items
          .filter((item) => item.properties && item.properties['bundle-product'] === 'true')
          .map((item) => item.key);

        // 3. Remove existing bundles (if any)
        if (bundleKeys.length > 0) {
          const updates = {};
          bundleKeys.forEach((key) => {
            updates[key] = 0; // remove
          });

          await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates }),
          });
        }

        // 4. Prepare new bundle items
        const items = Object.entries(this.cartItems).map(([id, item]) => ({
          id, // variant id
          quantity: item.quantity,
          properties: {
            'bundle-product': 'true',
          },
        }));

        // 5. Add new bundle items
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items }),
        });

        // 6. Clear local storage + redirect
        localStorage.removeItem('miniCart');
        window.location.href = '/cart';

        setTimeout(() => {
          addBundleBtn.removeAttribute('disabled', true);
        }, 300);
      } catch (error) {
        console.error('Error adding bundle:', error);
        alert('There was an error adding your bundle. Please try again.');
        addBundleBtn.removeAttribute('disabled', true);
      }
    }
  }

  new MiniCart({
    searchInput: 'searchInput',
    resultsContainer: 'searchResults',
    miniCartContainer: 'miniCartContainer',
    addBundleBtn: 'add-bundle',
  });
});

document.addEventListener("DOMContentLoaded", () => {
  const trigger = document.getElementById("mobile_bundle_text");
  const bundleSide = document.querySelector(".bundle-mini-cart-side");

  if (trigger && bundleSide) {
    trigger.addEventListener("click", () => {
      if (window.innerWidth <= 767) {
        bundleSide.classList.toggle("open");
        document.querySelector('body')?.classList.toggle('bundle-overflow');
        document.querySelector('.mobile-bundle__overlay')?.classList.toggle('show-overlay');
      }
    });
  }
});